import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { Link } from 'react-router-dom';
import Select from "react-select";
import Labels from '../Labels';
import Parsers from '../Tools/Parsers';
import Container from '../components/Container';
import ErrorComponent from '../components/ErrorComponent';
import PageComponent from '../components/PageComponent';
import Connection from '../config/Connection';
import '../styles/generics.css';
import './Home.js.css';

export default class Home extends PageComponent {

  static PageInfo = {
    path: "/",
    name: "menu.dashboard",
    access: { 1: true, 2: true },
    icon: "tasks"
  }

  constructor(props) {
    super(props);
    this.state = {
      error: null,
      loading: false,
      data: [],
      filter: []
    };
  }

  toogleSelection(target) {
    if (target.classList.contains("hidden"))
      target.classList.remove("hidden");
    else
      target.classList.add("hidden");
  }

  componentDidMount() {
    const lastYear = new Date().getFullYear();
    this.renderAllData([`${lastYear}/${lastYear + 1}`])

    Connection.Secure(Connection.service + 'ProgramGetLastYear')
      .then((response) => {
        console.log("response", response)
        if (response.ok && response.status == 200)
          response.json().then((data) => {
            console.log("data", data)
            const startYear = data.year;
            const currentYear = new Date().getFullYear();
            const filter = [];

            for (let year = startYear; year <= currentYear; year++) {
              filter.push({
                value: `${year}/${year + 1}`,
                label: `${year}/${year + 1}`
              });
            }
            this.setState({ filter: filter })
          });
        else this.setState({ error: response, loading: false });
      })
      .catch((error) => {
        this.setState({ error: error, loading: false });
      });
  }

  extractFirstNumber = arr => {
    return arr.map(item => item.split('/')[0]);
  };

  renderAllData(safraDate) {
    if (safraDate.length > 0) {
      this.setState({ loading: true });

      const extractedNumbers = this.extractFirstNumber(safraDate);
      const data = JSON.stringify({ years: extractedNumbers });

      Connection.Secure(Connection.service + 'PendingGetAll', {
        "method": "POST",
        "headers": {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: data
      })
        .then((response) => {
          if (response.ok && response.status == 200)
            response.json().then((data) => {
              this.setState({ error: null, loading: false, data: data });
            });
          else this.setState({ error: response, loading: false });
        })
        .catch((error) => {
          this.setState({ error: error, loading: false });
        }).finally(() => {
          this.setState({ loading: false });
        });
    }
  }

  renderInvoice(t, g, p) {
    return <div className="item_listing" style={{ position: "relative" }}>
      <div style={{ float: "left" }}>
        <Link to={"/Program/Detail/" + t.programId + "/Goal/" + t.mainCompany.keyRegister + "/ActionPlan/" + p.data.qaActionPlanId + "/Invoice/" + p.data.invoice.id} className="program_item">
          <FontAwesomeIcon icon={"dollar-sign"} className="generics_listing_item_icon" style={{
            opacity: 1, color: Parsers.GetStatusColor(p.status, "invoice")
          }} />
          <div className="generics_listing_item_title" style={{ color: Parsers.GetStatusColor(p.status, "invoice") }}>{p.data.invoice.title}</div>
        </Link>
        <div style={{ marginTop: -15, marginLeft: 46, fontSize: 12 }}>{Parsers.parseMoney(p.data.invoice.valueTotal)}</div>
      </div>
      <div style={{ fontSize: 12, float: "right", margin: 10, color: Parsers.GetStatusColor(p.status, "invoice") }}>{Labels.GetLabel("STATUS_PROGRAM_REFUND." + p.status)}</div>
      <div style={{ clear: "both" }}></div>
      <div className="item_listing_lines_tilt" style={{}}></div>
      <div className="item_listing_lines" style={{ height: g.toDos.indexOf(p) == g.toDos.length - 1 ? 25 : "auto" }}></div>
    </div>
  }

  renderActionPlan(t, g) {
    return <div className="item_listing" style={{ position: "relative" }}>
      {g.toDos == null || g.toDos.length == 0 ? null :
        <div className="item_listing_show" onClick={t => this.toogleSelection(t.currentTarget.parentNode)}>
          <FontAwesomeIcon icon={"plus"} className="item_listing_show_icon" />
        </div>
      }
      <div style={{ float: "left" }}>
        <Link to={"/Program/Detail/" + t.programId + "/Goal/" + t.mainCompany.keyRegister + "/QualitativeAward"} className="program_item">
          <FontAwesomeIcon icon={"money-bill-wave"} className="generics_listing_item_icon" style={{
            opacity: 1, color: Parsers.GetStatusColor(g.status, "actionplan")
          }} />
          <div className="generics_listing_item_title" style={{ color: Parsers.GetStatusColor(g.status, "actionplan"), fontSize: 14 }}>{Labels.GetLabel("program_schedule.qa")}</div>
        </Link>
        <div style={{ marginTop: -15, marginLeft: 46, fontSize: 12 }}>{Parsers.parseMoney(g.data.totalInvestment)} / {Parsers.parseMoney(g.data.maximumInvestment)}</div>
      </div>
      <div style={{ fontSize: 12, float: "right", margin: 10, color: Parsers.GetStatusColor(g.status, "actionplan") }}>{Labels.GetLabel("STATUS_PROGRAM_REFUND." + g.status)}</div>
      <div style={{ clear: "both" }}></div>
      {
        g.toDos == null ? null :
          g.toDos.map(p => this.renderInvoice(t, g, p))
      }
      <div className="item_listing_lines_tilt"></div>
      <div className="item_listing_lines" style={{ height: t.toDos.indexOf(g) == t.toDos.length - 1 ? 25 : "auto" }}></div>
    </div >
  }

  renderGoal(p, t) {

    var c = null;
    for (let i = 0; i < p.clientDetails.length && c == null; i++) {
      const element = p.clientDetails[i];
      if (element != null && element.customerCode == t.mainCompany.keyRegister)
        c = element;
    }

    return c == null ? null : <div className="item_listing" style={{ position: "relative" }}>
      {t.toDos == null || t.toDos.length == 0 ? null :
        <div className="item_listing_show" onClick={t => this.toogleSelection(t.currentTarget.parentNode)}>
          <FontAwesomeIcon icon={"plus"} className="item_listing_show_icon" />
        </div>
      }
      <div style={{ float: "left" }}>
        <Link to={"/Program/Detail/" + t.programId + "/Goal/" + c.customerCode + (Parsers.parsePermission2(["GOAL_ACCESS"]) ? "" : "/QualitativeAward/")} className="program_item">
          <FontAwesomeIcon icon={"award"} className="generics_listing_item_icon" style={{
            opacity: 1, color: Parsers.GetStatusColor(t.status, "goal")
          }} />
          <div className="generics_listing_item_title" style={{
            fontSize: 14,
            color: Parsers.GetStatusColor(t.status, "goal")
          }}>#{parseInt(c.customerCode)} -
            {c.name1 + (c.name2 == null ? "" : c.name2)
              + (c.name3 == null ? "" : c.name3)
              + (c.name4 == null ? "" : c.name4)}
          </div>
        </Link>
        <div style={{ marginTop: -15, marginLeft: 46, fontSize: 12 }}>{Parsers.parseNumber(t.data.goal, true)} {Labels.GetLabel("UNIT_TYPE_UNIT.1")}</div>
      </div>
      <div style={{ fontSize: 12, margin: 10, color: Parsers.GetStatusColor(t.status, "goal"), float: "right" }}>{Labels.GetLabel("STATUS_PROGRAM." + t.status)}</div>
      <div style={{ clear: "both" }}></div>
      {t.toDos == null ? null :
        t.toDos.map(g => this.renderActionPlan(t, g))
      }
      <div className="item_listing_lines_tilt" style={{ marginLeft: 0 }}></div>
      <div className="item_listing_lines" style={{ marginLeft: 0, height: p.toDos.indexOf(t) == p.toDos.length - 1 ? 25 : "auto" }}></div>
    </div>
  }

  renderProgram(t) {
    var item = t.program;
    var link = "/Program/Detail/" + item.id + (Parsers.parsePermission2(["PROGRAM_ACCESS"]) ? "" : "/Goals/");
    return <div className="item_listing" style={{ position: "relative" }}>
      {t.toDos == null || t.toDos.length == 0 ? null :
        <div className="item_listing_show" onClick={t => this.toogleSelection(t.currentTarget.parentNode)}>
          <FontAwesomeIcon icon={"plus"} className="item_listing_show_icon" />
        </div>
      }
      <div className="generics_listing_item" style={{ display: "block", paddingTop: 0, border: "0px" }}>
        <Link to={link} className="program_item">
          <FontAwesomeIcon icon="trophy" className="generics_listing_item_icon" style={{
            opacity: 1
          }} />
          <div className="generics_listing_item_title" style={{
            color: Parsers.GetStatusColor(t.status),
            fontSize: 14
          }}>{item.label}</div>
        </Link>
        <div style={{ marginTop: -15, marginLeft: 46, fontSize: 12 }}>{item.brand.label} -
          {/* {Labels.GetLabel(item.fkClientType == null ? 'generic.all' : 'CLIENT_TYPE.' + item.fkClientType)} */}
          {" " + Labels.GetLabel("program.hierarchy_" + (item.hierarchy == true))}
        </div>
      </div>
      {t.toDos.map(g => this.renderGoal(t, g))}
      <div className="item_listing_lines" style={{ marginLeft: 0, height: this.state.data.indexOf(t) == this.state.data.length - 1 ? 25 : "auto" }}></div>
      <div className="item_listing_lines_tilt" style={{ marginLeft: 0 }}></div>
    </div>;
  }

  render() {
    return (
      <Container context={this.constructor}>
        {
          this.state.error != null ? <ErrorComponent error={this.state.error} /> :
            <div className="generics_panels" style={{ display: "block", flexDirection: "column" }}>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <div className="generics_panels_header"><FontAwesomeIcon icon={this.constructor.PageInfo.icon} /> <span>{Labels.GetLabel(this.constructor.PageInfo.name)}</span></div>
                <div className="generics_label_select">{Labels.GetLabel("generic.status2")}</div>
                <Select
                  isMulti
                  options={this.state.filter}
                  onChange={x => this.renderAllData(x.map(option => option.value))}
                />
                <div className="generics_description_select">*{Labels.GetLabel("generic.allstates2")}</div>
              </div>
              <div>
                <div className="generics_panels_header"><FontAwesomeIcon icon="list" /> <span>{Labels.GetLabel("clients.results")} ({Array.isArray(this.state.data) ? this.state.data.length : 0})</span></div>
                {
                  this.state.loading ? <div>{Labels.GetLabel("generic.loading")}</div> : (
                    !Array.isArray(this.state.data) || this.state.data.length == 0 ?
                      <div className="generic_empty">{Labels.GetLabel('adminstategroupdetail.empty')}</div>
                      :
                      this.state.data.map(t => this.renderProgram(t))
                  )
                }
              </div>
            </div>
        }
      </Container>
    );
  }
}